var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "version-chain" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            name: "basic-t",
            title: _vm.dialogTitle,
            "close-on-click-modal": _vm.closeOnClickModal1,
            modal: true,
            width: 668,
            confirmButtonText: _vm.suredown,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            confirm: _vm.handleConfirm,
            "after-close": _vm.handleAfterClose,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-box" },
            _vm._l(_vm.forData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "horizontal-array" },
                _vm._l(item, function (itemdata, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "inner-array",
                      class: [
                        itemdata.software_version == _vm.chainSoftware_version
                          ? "yes-check"
                          : "not-check",
                      ],
                    },
                    [
                      _c(
                        "v-popover",
                        {
                          staticClass: "popover-demo",
                          attrs: {
                            width: "auto",
                            trigger: "hover",
                            position: "right-top",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v("版本ID："),
                            _c("span", { staticClass: "boodBlack" }, [
                              _vm._v(_vm._s(itemdata.id)),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v("产品："),
                            _c("span", { staticClass: "boodBlack" }, [
                              _vm._v(_vm._s(itemdata.productName)),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v("软件版本："),
                            _c("span", { staticClass: "boodBlack" }, [
                              _vm._v(_vm._s(itemdata.software_version)),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v("版本类型："),
                            _c("span", { staticClass: "boodBlack" }, [
                              _vm._v(_vm._s(itemdata.version_type)),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v("支持语言："),
                            _c("span", { staticClass: "boodBlack" }, [
                              _vm._v(_vm._s(itemdata.language)),
                            ]),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "inlinebliok",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            },
                            [_vm._v(_vm._s(itemdata.productName))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "inlinebliok",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            },
                            [_vm._v(_vm._s(itemdata.software_version))]
                          ),
                        ]
                      ),
                      i === 0 && _vm.forData.length !== index + 1
                        ? _c("span", { staticClass: "right-line overstep" })
                        : _vm._e(),
                      i !== 0 && _vm.forData.length !== index + 1
                        ? _c("span", { staticClass: "left-line overstep" })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }